import '../../../styles/ods-v2/index.css'

import './Components/jquery-confirm'
import './Components/Tabs'
import './burger-menu'
import './Elements/ooredoo-select'
import './Components/Shop'
import '../../shared/ekyc/ekyc'

import {OoredooIcon} from "./Components/OoredooIcon";
import {errorAlert} from "./Components/jquery-confirm";

(($) => {
    $(document).ready(function () {

        $('body').on('input blur paste', '.phone-input,.numeric-input,.msisdn,[name="verification_code"]', function (e) {
            $(this).val($(this).val().replace(/\D/g, ''))
        });


        $('body').on('click', '#activate-ar-btn', function (e) {
            // console.log('e',$('model-viewer')[0])
            // alert(JSON.stringify(e));
        });
        $('body').on('click', '.product-3d-ar-action__btn', function (e) {
            e.preventDefault();
            if ($(this).hasClass('is-active')) {
                return;
            }

            if ($(this).data('view_type') == 'ar' && ($(this).data('is_mobile') == 'true' || $(this).data('is_mobile') === true)) {
                const mv = $('model-viewer')[0];
                if(mv.canActivateAR){
                    $('model-viewer')[0].activateAR(function (a,b){
                    });
                }else{
                    errorAlert(`عذراً، جهازك لا يدعم هذه الخاصية!`,{
                        icon:'icon-Icon-16'
                    });
                }
                return;
            }
            $(this).closest('.single-product-3d-ar-actions').find('.is-active').removeClass('is-active');
            $(this).addClass('is-active');
            const root = $(this).closest('.pp__image-slider');
            root.find('.item.is-active').removeClass('is-active');
            const items = root.find(`.item[data-item_type="${$(this).data('view_type')}"]`);
            items.addClass('is-active');
        });

        $(window).on('legocms.uploading_started', function (event, data) {
            const form = data.input.closest('form');
            form.addClass('has-uploading-process');
            const btn = form.find('button:not([type="button"]):not([type="reset"])');
            btn.attr('disabled', true);
        });
        $(window).on('legocms.uploading_completed', function (event, data) {
            const form = data.input.closest('form');
            form.removeClass('has-uploading-process');

            const btn = form.find('button:not([type="button"]):not([type="reset"])');
            btn.attr('disabled', false);

        });

        $(window).on('legocms.uploading_file.failed', function (event, data) {
            const form = data.input.closest('form');
            const inputWrapper = data.input.closest('.attachments-item-box');
            const errorEl = inputWrapper.find('.lego-msg.error');


            if (errorEl.length) {
                let feedbackEl = inputWrapper.find('.ods-form-group__feedback');
                if (!feedbackEl.length) {
                    feedbackEl = ('<div class="ods-form-group__feedback"></div>')
                }
                feedbackEl.empty();
                const msgEl = $('<div class="ods-form-group__feedback__msg"></div>');
                msgEl.append(errorEl);
                feedbackEl.append(msgEl);
            }

            return false;
        });

        $(window).on('legocms.uploading_file.success', function (event, data) {
        });
        const setWindowHeight = function () {
            const elements = [

                $('header'),
                $('footer'),
                $('.app-mode')
            ];
            let h = $(window).height() - 15;
            $.each(elements, function (idx, el) {
                if ($(el).length) {
                    h -= $(el).height();
                }
            });
            $('#content-wrapper').css('minHeight', h)
        }

        setWindowHeight();

        const popup = () => {

            const odsPopup = $('body').find('#ods-popup');
            if (!odsPopup.length) {
                return;
            }
            let icon = odsPopup.data('icon');
            if (typeof icon == 'undefined') {
                icon = 'icon-Icon-441';
            }
            // let img = odsPopup.find('.ods-popup__img');
            let content = odsPopup.find('.ods-popup__content');
            if (!content.length) {
                return;
            }
            // console.log('content',img)
            // console.log('content',content)
            $.alert({
                title: '',
                iconHtml: OoredooIcon(icon),
                content: `${content.html()}`,
                columnClass: 'column is-8',
                bootstrapClasses: {
                    container: 'container ods-modal',
                    containerFluid: 'container-fluid',
                    row: 'row columns is-multiline'
                },
                buttons: {
                    close: {
                        text: window.application.ods.js_trans.continue,
                        btnClass: 'main-btn',

                    },
                }

            });
        }

        popup();

    });
})(jQuery);
